import {ComponentBase} from "../../../_snowpack/link/dist/@salaxy/ng1/salaxy-lib-ng1.js";
import {ProController} from "../../controllers/pro/index.js";
export class ProAccounts extends ComponentBase {
  constructor() {
    super(...arguments);
    this.bindings = {
      serviceModelId: "<"
    };
    this.transclude = {
      header: "?header",
      filter: "?filter"
    };
    this.controller = ProController;
    this.defaultTemplate = "views/templates/pro-accounts.html";
  }
}
